import { useContext } from "react";

import { InternalPartnerAccessContext } from "../context/PartnerAccessContext";
import { IPartnerAccessContext } from "../types/partner/IPartnerAccessContext";

/**
 * Reads the signed-in user's partner access from the PartnerAccessProvider.
 * Throws outside the provider so misuse is caught during development.
 *
 * @returns The current partner access value.
 */
export function usePartnerAccess(): IPartnerAccessContext {
  const context = useContext(InternalPartnerAccessContext);
  if (!context) {
    throw new Error("usePartnerAccess must be used within a PartnerAccessProvider");
  }
  return context;
}
